import type { FC } from 'react';
import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import { Image } from 'Components/Gallery/Image';
import type { GalleryImageWithTitle } from 'Components/Gallery/MainGallery/MainGallery';
import type { GalleryImage } from 'Pages/vehicles/helpers/vehicle.schema';
import { triggerSectionImageClickedEvent } from 'Services/analytics/events/galleryEventsRedesign';
import { applyCypressData } from 'Utilities/helpers';

import { useGalleryTrigger } from '../../../Components/GalleryProvider';
import LocalTexts from '../ServiceHistoryEnhancedSection.texts.json';

import styles from './ImagesPreview.module.scss';

const LocalT = new MDText(LocalTexts);

interface ImagesPreviewProps {
	images: GalleryImageWithTitle[];
}

const NUMBER_OF_IMAGES_TO_SHOW = 2;

export const ImagesPreview: FC<ImagesPreviewProps> = ({ images }) => {
	const triggerGalleryOpen = useGalleryTrigger();
	const { length: imagesCount } = images;

	const handleOnClick = ({ id, kind }: Pick<GalleryImage, 'id' | 'kind'>) => {
		triggerGalleryOpen({ id });
		triggerSectionImageClickedEvent({ kind });
	};

	return (
		<div className={styles.container} {...applyCypressData(cypressIds.containers.serviceHistoryGallery)}>
			{images.slice(0, NUMBER_OF_IMAGES_TO_SHOW).map(({ id, kind, presets }) => (
				<Image key={id} onClick={() => handleOnClick({ id, kind })} sizes="432w" src={presets.mobile} widths={[432]} />
			))}
			{imagesCount > 1 && (
				<div className={styles.showMore}>{LocalT.translate('images.viewMore', { count: imagesCount - 1 })}</div>
			)}
		</div>
	);
};
